var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85547 0C7.28517 0 7.71483 0 8.14453 0C9.58995 0.141977 10.8888 0.64979 12.041 1.52344C9.01368 1.52344 5.98632 1.52344 2.95898 1.52344C4.11123 0.64979 5.41005 0.141977 6.85547 0Z",
    fill: "#FBBC0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95898 1.52344C5.98632 1.52344 9.01368 1.52344 12.041 1.52344C12.2244 1.63947 12.3904 1.77619 12.5391 1.93359C9.17968 1.93359 5.82032 1.93359 2.46094 1.93359C2.60961 1.77619 2.77562 1.63947 2.95898 1.52344Z",
    fill: "#FBBC0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46094 1.93359C5.82032 1.93359 9.17968 1.93359 12.5391 1.93359C12.9527 2.2843 13.3042 2.68469 13.5938 3.13477C9.53124 3.13477 5.46876 3.13477 1.40625 3.13477C1.69577 2.68469 2.04734 2.2843 2.46094 1.93359Z",
    fill: "#FBBC0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40625 3.13672C5.46876 3.13672 9.53124 3.13672 13.5938 3.13672C13.6847 3.21802 13.7531 3.31566 13.7988 3.42969C9.59962 3.42969 5.40038 3.42969 1.20117 3.42969C1.24694 3.31566 1.31529 3.21802 1.40625 3.13672Z",
    fill: "#FBBC0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20117 3.42578C5.40038 3.42578 9.59962 3.42578 13.7988 3.42578C14.0922 3.82686 14.3168 4.26631 14.4727 4.74414C12.4316 4.74414 10.3906 4.74414 8.34961 4.74414C8.43832 4.09026 8.15511 3.7094 7.5 3.60156C6.84489 3.7094 6.56168 4.09026 6.65039 4.74414C4.60937 4.74414 2.56836 4.74414 0.527344 4.74414C0.683218 4.26631 0.907828 3.82686 1.20117 3.42578Z",
    fill: "#FBBC0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.527344 4.74609C2.56836 4.74609 4.60937 4.74609 6.65039 4.74609C6.67567 4.80237 6.69519 4.86097 6.70898 4.92188C4.61915 4.92188 2.5293 4.92188 0.439453 4.92188C0.457916 4.85596 0.487213 4.79736 0.527344 4.74609Z",
    fill: "#FBBC0B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34961 4.74609C10.3906 4.74609 12.4316 4.74609 14.4727 4.74609C14.5128 4.79736 14.5421 4.85596 14.5605 4.92188C12.4707 4.92188 10.3808 4.92188 8.29102 4.92188C8.30481 4.86097 8.32433 4.80237 8.34961 4.74609Z",
    fill: "#FBBC0B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.439453 4.92188C2.5293 4.92188 4.61915 4.92188 6.70898 4.92188C7.23633 5.54687 7.76367 5.54687 8.29102 4.92188C10.3808 4.92188 12.4707 4.92188 14.5605 4.92188C14.7379 5.40659 14.8648 5.90464 14.9414 6.41602C12.6562 6.41602 10.3711 6.41602 8.08594 6.41602C8.10812 6.25213 8.04952 6.13005 7.91016 6.0498C7.67303 6.01699 7.43379 6.00234 7.19238 6.00586C6.95098 6.00234 6.71174 6.01699 6.47461 6.0498C6.34295 6.13438 6.29411 6.25646 6.32812 6.41602C4.23829 6.41602 2.14844 6.41602 0.0585938 6.41602C0.135168 5.90464 0.262121 5.40659 0.439453 4.92188Z",
    fill: "#FBBC0B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0585938 6.41797C2.14844 6.41797 4.23829 6.41797 6.32812 6.41797C6.38587 6.48559 6.44446 6.55396 6.50391 6.62305C4.34569 6.62305 2.1875 6.62305 0.0292969 6.62305C0.0503502 6.55672 0.0601157 6.48837 0.0585938 6.41797Z",
    fill: "#FBBC0B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08594 6.41797C10.3711 6.41797 12.6562 6.41797 14.9414 6.41797C14.9399 6.48837 14.9496 6.55672 14.9707 6.62305C12.6758 6.62305 10.3808 6.62305 8.08594 6.62305C8.08594 6.5547 8.08594 6.48632 8.08594 6.41797Z",
    fill: "#FBBC0B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0292969 6.62109C2.1875 6.62109 4.34569 6.62109 6.50391 6.62109C6.63958 6.74209 6.77142 6.86903 6.89941 7.00195C6.91406 7.39245 6.91895 7.7831 6.91406 8.17383C4.61915 8.17383 2.32422 8.17383 0.0292969 8.17383C0.0292969 8.15429 0.0195313 8.14453 0 8.14453C0 7.71483 0 7.28517 0 6.85547C0.0285078 6.78375 0.0382734 6.70562 0.0292969 6.62109Z",
    fill: "#FBBC0B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08594 6.62109C10.3808 6.62109 12.6758 6.62109 14.9707 6.62109C14.9617 6.70562 14.9715 6.78375 15 6.85547C15 7.28517 15 7.71483 15 8.14453C14.9805 8.14453 14.9707 8.15429 14.9707 8.17383C12.6758 8.17383 10.3808 8.17383 8.08594 8.17383C8.08594 7.65624 8.08594 7.13868 8.08594 6.62109Z",
    fill: "#FBBC0B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0292969 8.17578C2.32422 8.17578 4.61915 8.17578 6.91406 8.17578C6.91406 8.19532 6.91406 8.21483 6.91406 8.23438C4.61915 8.23438 2.32422 8.23438 0.0292969 8.23438C0.0292969 8.21483 0.0292969 8.19532 0.0292969 8.17578Z",
    fill: "#FBBC0B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08594 8.17578C10.3808 8.17578 12.6758 8.17578 14.9707 8.17578C14.9707 8.19532 14.9707 8.21483 14.9707 8.23438C12.6758 8.23438 10.3808 8.23438 8.08594 8.23438C8.08594 8.21483 8.08594 8.19532 8.08594 8.17578Z",
    fill: "#FBBC0B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0292969 8.23047C2.32422 8.23047 4.61915 8.23047 6.91406 8.23047C6.91406 8.70897 6.91406 9.18751 6.91406 9.66602C4.70704 9.66602 2.5 9.66602 0.292969 9.66602C0.157743 9.19647 0.0698522 8.71797 0.0292969 8.23047Z",
    fill: "#FBBC0B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08594 8.23047C10.3808 8.23047 12.6758 8.23047 14.9707 8.23047C14.9302 8.71797 14.8423 9.19647 14.707 9.66602C12.5 9.66602 10.293 9.66602 8.08594 9.66602C8.08594 9.18751 8.08594 8.70897 8.08594 8.23047Z",
    fill: "#FBBC0B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292969 9.66797C2.5 9.66797 4.70704 9.66797 6.91406 9.66797C6.91406 9.72656 6.91406 9.78516 6.91406 9.84375C4.72655 9.84375 2.53906 9.84375 0.351562 9.84375C0.337772 9.78284 0.318243 9.72425 0.292969 9.66797Z",
    fill: "#FBBC0B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08594 9.66797C10.293 9.66797 12.5 9.66797 14.707 9.66797C14.6817 9.72425 14.6622 9.78284 14.6484 9.84375C12.4609 9.84375 10.2734 9.84375 8.08594 9.84375C8.08594 9.78516 8.08594 9.72656 8.08594 9.66797Z",
    fill: "#FBBC0B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.351562 9.84375C2.53906 9.84375 4.72655 9.84375 6.91406 9.84375C6.91893 10.0296 6.91406 10.2151 6.89941 10.4004C6.72363 10.5762 6.54785 10.752 6.37207 10.9277C6.33539 11.0014 6.32074 11.0795 6.32812 11.1621C4.53126 11.1621 2.73437 11.1621 0.9375 11.1621C0.702463 10.7408 0.507149 10.3014 0.351562 9.84375Z",
    fill: "#FBBC0B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08581 9.84375C10.2733 9.84375 12.4608 9.84375 14.6483 9.84375C14.4927 10.3014 14.2974 10.7408 14.0624 11.1621C12.2655 11.1621 10.4686 11.1621 8.67174 11.1621C8.67913 11.0795 8.66448 11.0014 8.6278 10.9277C8.45202 10.752 8.27624 10.5762 8.10046 10.4004C8.08581 10.2151 8.08094 10.0296 8.08581 9.84375Z",
    fill: "#FBBC0B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 11.1602C2.73437 11.1602 4.53126 11.1602 6.32812 11.1602C6.36861 11.2881 6.4565 11.3614 6.5918 11.3799C7.19728 11.3994 7.80272 11.3994 8.4082 11.3799C8.5435 11.3614 8.63139 11.2881 8.67188 11.1602C10.4687 11.1602 12.2656 11.1602 14.0625 11.1602C14.0039 11.2578 13.9453 11.3555 13.8867 11.4531C9.62892 11.4531 5.37108 11.4531 1.11328 11.4531C1.05469 11.3555 0.996094 11.2578 0.9375 11.1602Z",
    fill: "#FBBC0B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.11328 11.457C5.37108 11.457 9.62892 11.457 13.8867 11.457C13.6181 11.8917 13.3056 12.2921 12.9492 12.6582C9.31641 12.6582 5.68359 12.6582 2.05078 12.6582C1.69444 12.2921 1.38194 11.8917 1.11328 11.457Z",
    fill: "#FBBC0B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05078 12.6562C5.68359 12.6562 9.31641 12.6562 12.9492 12.6562C12.7322 12.9124 12.4881 13.137 12.2168 13.3301C9.07228 13.3301 5.92772 13.3301 2.7832 13.3301C2.51193 13.137 2.26779 12.9124 2.05078 12.6562Z",
    fill: "#FBBC0B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7832 13.332C5.92772 13.332 9.07228 13.332 12.2168 13.332C11.6838 13.7893 11.088 14.1506 10.4297 14.416C8.48634 14.416 6.54296 14.416 4.59961 14.416C3.92827 14.1587 3.32282 13.7974 2.7832 13.332Z",
    fill: "#FBBC0B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59961 14.4141C6.54296 14.4141 8.48634 14.4141 10.4297 14.4141C9.69814 14.7288 8.93643 14.9241 8.14453 15C7.71483 15 7.28517 15 6.85547 15C6.40512 14.946 5.95588 14.863 5.50781 14.751C5.19006 14.6696 4.88733 14.5573 4.59961 14.4141Z",
    fill: "#FBBC0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c991c080027be187c9ab47268cd3c484.svg";
export { ForwardRef as ReactComponent };